export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '最新院线大片、经典电影回顾、高分必看佳片' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', description: '热门国产剧、海外剧集、独家热播连续剧' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '搞笑综艺、真人秀、音乐竞演、脱口秀' },
  { slug: 'dongman', name: '动漫', icon: 'ri-ghost-line', description: '热血动漫、国产动画、日漫新番连载' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '自然探索、历史揭秘、人文纪实、科技前沿' },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-2-line', description: 'MV首播、演唱会现场、音乐节目精选' },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', description: '游戏实况、电竞比赛、新游评测、攻略解说' },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line', description: '赛事直播回放、体育集锦、竞技时刻' },
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);